export const blogPosts = [
  {
    slug: "broken-workflows",
    title: "Different Symptoms, Same Problem: AI is the Medicine",
    date: "Fri 2nd May 2025",
    topic: "Automation",
    subheading: "From dentists to data teams, the hidden cost of manual work is everywhere - but AI is changing that",
    seo_description: "Explore how automation is solving the hidden inefficiencies plaguing UK businesses - from missed appointments to spreadsheet overload. Discover how DataPulse AI helps teams reclaim time, reduce stress, and scale smarter.",
    image: "/assets/images/blog/broken-workflows.jpg",
    readingTime: "6 min",
    importPath: () => import("../content/broken-workflows")
  },
  {
    slug: "systems-that-scale",
    title: "Systems That Scale: How Automation Replaces Manual Chaos with Smart Workflows",
    date: "Mon 5th May 2025",
    topic: "Automation",
    subheading: "From reminders to real-time dashboards, DataPulse AI builds systems that work - so your team can focus on growth",
    seo_description: "Discover how DataPulse AI helps UK businesses escape the cycle of manual reminders, dashboards, and team bottlenecks - and replace them with seamless, scalable workflows.",
    image: "/assets/images/blog/systems-that-scale.jpg",
    readingTime: "6 min",
    importPath: () => import("../content/systems-that-scale")
  },
  {
    slug: "why-teams-choose-us",
    title: "Why Growing Teams Trust DataPulse AI",
    date: "Weds 7th May 2025",
    topic: "Automation",
    subheading: "Simple, powerful automation - backed by real expertise and done-for-you delivery",
    seo_description: "Find out why modern teams are choosing DataPulse AI over DIY tools. With plug-and-play integrations, expert support, and full implementation handled for you, we bring automation to life - with results you can feel.",
    image: "/assets/images/blog/why-teams-choose-us.jpg",
    readingTime: "5-6 min",
    importPath: () => import("../content/why-teams-choose-us")
  },{
    slug: "ai-in-dentistry",
    title: "The AI Boom in UK Dentistry",
    date: "Fri 9th May 2025",
    topic: "Dentistry",
    subheading: "How early adopters are gaining a competitive edge",
    seo_description: "Explore how UK dental clinics are gaining a competitive edge with AI. From faster diagnostics to automated operations and higher patient engagement, AI is helping forward-thinking practices streamline care, increase revenue, and stay ahead in a growing market.",
    image: "/assets/images/blog/dental_edge_datapulse_img.jpg",
    readingTime: "5 min",
    importPath: () => import("../content/ai-in-dentistry"),
  },{
    slug: "ai-in-accounting",
    title: "Balancing the Books with Bots: How AI is Reshaping UK Accountancy",
    date: "Mon 12th May 2025",
    topic: "Accounting",
    subheading: "Embracing AI for Enhanced Accuracy and Efficiency in Accounting.",
    seo_description: "AI is transforming UK accountancy by automating routine work, enhancing compliance, and enabling data-driven insights. Discover how firms are saving time, reducing risk, and scaling profitably using AI tools - and why those who adopt it now are staying essential in a changing industry.",
    image: "/assets/images/blog/ai-in-accounting.jpg",
    readingTime: "7 min",
    importPath: () => import("../content/ai-in-accounting"),
  },{
  slug: "ai-leadership-lessons",
  title: "Beyond the Hype: What the Real AI Leaders Are Actually Saying",
  date: "Fri 22nd May 2025",
  topic: "Blog",
  subheading: "8 powerful lessons from industry leaders at the Digital Transformation Conference 2025",
  seo_description: "What are AI leaders at Tesco, Unilever, GSK, and more really saying? Discover 8 candid takeaways on AI transformation from the front lines - and why tech is often the easy part.",
  image: "/assets/images/blog/ai-leadership-lessons.jpg",
  readingTime: "6-7 min",
  importPath: () => import("../content/ai-leadership-lessons")
}
];
